import OddType from '@models/struct/OddType';
import { OutcomeDto } from './dtos/OutcomeDto';

export function mapOddTypes(outcomeDtos: OutcomeDto[]): OddType[] {
    return outcomeDtos.map((outcomeDto) => {
        return {
            id: outcomeDto.id,
            name: outcomeDto.columnName,
        };
    });
}
